import { FormReadonly } from 'components/form-fields';
import PropTypes from 'prop-types';
import React from 'react';

export function OcrFixedPercentageRedGreen(
    {
        loading = false,
        disabled = false,
        layout
    }
) {

    function getClassName() {
        var redBoundary = 45;
        var greenBoundary = 75;
        var className = '';
        if (layout.answer) {
            className = 'cell-percentage form-field-';
            if (layout.answer <= redBoundary) {
                className = className + "red";
            }
            if (layout.answer > redBoundary && layout.answer < greenBoundary) {
                className = className + "amber";
            } else if (layout.answer >= greenBoundary) {
                className = className + "green";
            }
        }

        return className;
    }

    return (
        <FormReadonly
            headingText={layout.secondaryLayoutTitle ? layout.secondaryLayoutTitle : ''}
            value={layout.answer}
            loading={loading}
            largerValueText={!layout.secondaryLayoutTitle}
            className={getClassName()}
        />
    );
}

OcrFixedPercentageRedGreen.propTypes = {
    loading: PropTypes.bool,
    layout: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool
};
